import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.333 3.75c0-.092.075-.167.167-.167h9.352a.8.8 0 0 0-.019.167v16.5q0 .086.019.166H6.5a.167.167 0 0 1-.167-.166v-2.917h1.084a.75.75 0 0 0 0-1.5H6.333V12.75h1.084a.75.75 0 0 0 0-1.5H6.333V8.167h1.084a.75.75 0 1 0 0-1.5H6.333zm10.982 16.666h2.018a.167.167 0 0 0 .167-.166V3.75a.167.167 0 0 0-.167-.167h-2.018q.018.081.018.167v16.5a.8.8 0 0 1-.018.166M4.833 20.25v-2.917H3.75a.75.75 0 0 1 0-1.5h1.083V12.75H3.75a.75.75 0 0 1 0-1.5h1.083V8.167H3.75a.75.75 0 1 1 0-1.5h1.083V3.75c0-.92.746-1.667 1.667-1.667h12.833c.92 0 1.667.746 1.667 1.667v16.5c0 .92-.746 1.666-1.667 1.666H6.5c-.92 0-1.667-.746-1.667-1.666",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }